import { produce as applyImmutably } from 'immer';
function validateTimeouts(values, errors, timeoutsProperty, switchProperty) {
    const timeouts = values[timeoutsProperty];
    const validatedTimeouts = applyImmutably(timeouts, (draftState) => {
        Object.keys(draftState).forEach((channel) => {
            const channelTimeout = draftState[channel];
            if (isNaN(channelTimeout) || channelTimeout < 0) {
                errors[switchProperty] = 'Invalid';
            }
        });
    });
    return validatedTimeouts;
}
export function validateQueuesSettingsForm(values) {
    const errors = {};
    if (!values) {
        return errors;
    }
    if (!values.name) {
        errors.name = 'Required';
    }
    else if (values.name.length <= 1) {
        errors.name = 'Must be 2 characters or more';
    }
    if (values.offer_timeout) {
        if (isNaN(Math.floor(values.offer_timeout)) ||
            Math.floor(values.offer_timeout) <= 4 ||
            Math.floor(values.offer_timeout) > 300) {
            errors.offer_timeout =
                'The offer timeout should be between 5 - 300 seconds.';
        }
    }
    if (!values.offer_algorithm) {
        errors.offer_algorithm = 'Please select offer algorithm.';
    }
    if (values.do_not_offer_timeouts) {
        validateTimeouts(values, errors, 'do_not_offer_timeouts', 'is_do_not_offer_enabled');
    }
    if (values.preferred_agent_timeouts) {
        validateTimeouts(values, errors, 'preferred_agent_timeouts', 'is_preferred_agent_enabled');
    }
    if (values.wrapup_timeout) {
        if (isNaN(Math.floor(values.wrapup_timeout)) ||
            Math.floor(values.wrapup_timeout) <= 1 ||
            Math.floor(values.wrapup_timeout) > 300) {
            errors.wrapup_timeout =
                'The wrap-up time should be between 2 - 300 seconds.';
        }
    }
    return errors;
}
